import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';

import ReviewsPhotos from './ReviewsPhotos';

export default function ReviewsCard({ className, reviewCount, photographs }) {
  return (
    <div
      className={classnames(
        'ReviewsCard flex flex-column items-center gap-8 lh-title br3 bg-gray-100 ba b--gray-200 pt3 pb2 ph3',
        className
      )}
    >
      <ReviewsPhotos photographs={photographs} />
      <p className="flex items-center gap-4 font-14 secondary">
        <Icon name="fetch-review" height="20px" width="20px" />
        <span className="nowrap">
          {reviewCount} owner {reviewCount === 1 ? 'review' : 'reviews'}
        </span>
      </p>
    </div>
  );
}

ReviewsCard.propTypes = {
  className: PropTypes.string,
  reviewCount: PropTypes.number.isRequired,
  photographs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired
};

ReviewsCard.defaultProps = {
  className: null
};
